import { doggies } from './babyDogeDoggies'
import { CollectionKey, Nfts as NFTs } from '../types'
import { babydogeCollections } from './collections'

const nftCollections: NFTs = {
  [CollectionKey.BabyDoge]: doggies
}

export {
  nftCollections,
  babydogeCollections
}
